import { Box, Paper, Typography } from "@mui/material";
import { ACROSS_LOGO, AUTH_GRAPHICS, APB_ILLUSTRATION } from "../../assets";
import "./index.scss";

const AuthLayout = ({ children }) => (
  <Box
    className="auth-layout"
    style={{ backgroundImage: `url(${AUTH_GRAPHICS})` }}
  >
    <Paper elevation={3} className="auth-layout__paper">
      <Box className="auth-layout__left">
        <Box className="auth-layout__logo-container">
          <img
            alt="Across Logo"
            className="auth-layout__logo"
            src={ACROSS_LOGO}
          />
        </Box>

        <Typography variant="body2" className="auth-layout__subtitle">
          Welcome to the Admin Panel! Please log in to access and manage the
          system efficiently. Enter your credentials to ensure secure access to
          administrative features, monitor data, and oversee operations
          seamlessly. If you face any issues, contact support. Your security is
          our priority. Stay connected and in control!
        </Typography>

        <Box className="auth-layout__illustration">
          <img
            alt="Admin Illustration"
            className="auth-layout__illustration-img"
            src={APB_ILLUSTRATION}
          />
        </Box>

        <Typography variant="body2" className="auth-layout__footer">
          © 2023 Across Assist Pvt. Ltd.
        </Typography>
      </Box>

      <Box className="auth-layout__right">{children}</Box>
    </Paper>
  </Box>
);

export default AuthLayout;
